
import { Injectable } from "@angular/core";
import {
  CanActivate,
  CanActivateChild,
  Router,
  UrlTree,
  ActivatedRouteSnapshot,
} from "@angular/router";
import { jwtDecode, JwtPayload } from 'jwt-decode';
import { Observable } from "rxjs";
import { map } from "rxjs/operators";
import { AuthService } from "@services/auth/auth-service";
import { AppRoutes } from "@utils/constants";




/**
 * AuthGuard service.
 * Implements route guards to protect routes based on user authentication and roles.
 * Redirects unauthorized users to the login page or appropriate route.
 */
@Injectable({
  providedIn: "root",
})
export class AuthGuard implements CanActivate, CanActivateChild {
  /**
   * Constructs the AuthGuard service.
   * 
   * @param authService Service for authentication and user role retrieval
   * @param router Angular Router for navigation and redirection
   */
  constructor(
    private authService: AuthService,
    private router: Router
  ) { }

  /**
   * Determines if a route can be activated based on authentication and roles.
   * 
   * @param route The activated route snapshot
   * @returns Observable emitting true if access is allowed, or a UrlTree for redirection
   */
  // canActivate(route: ActivatedRouteSnapshot): Observable<boolean | UrlTree> {
  //   return this.checkAuth(route);
  // }

  /**
   * Determines if a child route can be activated based on authentication and roles.
   * 
   * @param route The activated route snapshot
   * @returns Observable emitting true if access is allowed, or a UrlTree for redirection
   */
  canActivateChild(
    route: ActivatedRouteSnapshot
  ): Observable<boolean | UrlTree> {
    return this.checkAuth(route);
  }

  /**
   * Checks authentication and role-based access for a route.
   * 
   * @param route The activated route snapshot
   * @returns Observable emitting true if access is allowed, or a UrlTree for redirection
   */
  private checkAuth(
    route: ActivatedRouteSnapshot
  ): Observable<boolean | UrlTree> {
    return this.authService.getUserRole().pipe(
      map((role: string) => {
        if (!role) {
          return this.router.createUrlTree([AppRoutes.LOGIN]);
        }

        const allowedRoles: string[] = route.data["roles"];

        if (!allowedRoles || allowedRoles.length === 0) {
          return true;
        }

        if (allowedRoles.includes(role)) {
          return true;
        }

        return this.router.createUrlTree([this.getRedirectUrl("0")]);
      })
      //   catchError(() => of(this.router.createUrlTree([AppRoutes.LOGIN])))
    );
  }

  /**
   * Returns the redirect URL based on the user's role.
   * 
   * @param role The user's role as a string
   * @returns The redirect route as a string
   */
  getRedirectUrl(role: string): string {
    switch (role) {
      case "0":
        return AppRoutes.DASHBOARD;
      default:
        return AppRoutes.LOGIN;
    }
  }
  /**
   * Determines if a route can be activated based on the presence of an authentication token in localStorage.
   * Redirects to the login page if the token is not found.
   *
   * @returns True if the token exists and access is allowed, false otherwise.
   */
  // canActivate(): boolean {
  //   const token: string | null = localStorage.getItem('token');
  //   if (token) {
  //     return true;
  //   } else {
  //     this.router.navigate(['/login']);
  //     return false;
  //   }
  // }

  canActivate(): boolean {
    const token: string | null = localStorage.getItem('token');

    if (!token) {
      this.router.navigate(['/login']);
      return false;
    }

    try {
      const decoded: JwtPayload = jwtDecode(token);
      const now: number = Date.now().valueOf() / 1000;

      if (decoded.exp && decoded.exp < now) {
        // Token expired
        localStorage.removeItem('token');
        this.router.navigate(['/login']);
        return false;
      }
      return true;
    } catch (e) {

      console.error(e)
      localStorage.removeItem('token');
      this.router.navigate(['/login']);
      return false;
    }
  }
}